import { CloseIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import {
    Box,
    Button,
    Center,
    Checkbox,
    Divider,
    Flex,
    FormControl,
    IconButton,
    Image,
    Input,
    Link,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio,
    RadioGroup,
    Skeleton,
    Stack,
    Text,
    Textarea,
    Tooltip,
    useDisclosure,
    useToast,
    useColorModeValue,
} from "@chakra-ui/react";
import SearchAdaccountAdspresso from "components/bmControl/SearchAdaccountAdspresso";
import { useFormik } from "formik";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { BsStars } from "react-icons/bs";
import { FiEye } from 'react-icons/fi';
import { useDispatch } from "react-redux";
import { useGetBmAdAccountsCountQuery, useGetBmAdAccountsQuery } from "store/BmAccounts/bmAccountApi";
import { useGenerateBackgroundImageMutation, useGenerateBackgroundPromptMutation, useGenerateCreativeVariationsMutation, useGeneratePromptMutation, useGetBackgroundImageStatusQuery, useRemoveBackgroundMutation } from "store/aiHub/aiGenerationApi";
import { setAfter, setBefore, setCurrentPage } from "store/campaigns/campaignsSlice";
import {
    useFinishUploadMutation,
    useStartUploadSessionMutation, useUploadChunkMutation,
    useUploadImageMutation
} from 'store/driveUpload/uploadApi';
import { setFiles, setIsWidgetOpen, updateUploadStatus } from "store/driveUpload/uploadSlice";
import { adUplaodSchema } from "utils/schema";

import { skipToken } from "@reduxjs/toolkit/dist/query";
import ReplaceDriveModal from "components/drive/ReplaceDriveModal";
import { base64ToFile, overlayImages, truncateName, urlToFile } from "utils/functions";

// Constants
const MAX_IMAGE_UPLOAD_SIZE_MB = 30; // Max size for images
const MAX_IMAGE_UPLOAD_SIZE_BYTES = MAX_IMAGE_UPLOAD_SIZE_MB * 1024 * 1024;

const UploadImageModal = ({ isOpen, onClose, onSuccess }) => {

    const backgroundColor = useColorModeValue('brand.50', 'purple.800');
    const textColor = useColorModeValue('purple.800', 'brand.50');
    const toast = useToast();
    const dispatch = useDispatch();
    const { isOpen: isDriveOpen, onOpen: onDriveOpen, onClose: onDriveClose } = useDisclosure();

    const [uploadImage, { isLoading: isImageLoading }] = useUploadImageMutation();
    const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [hasSearched, setHasSearched] = useState(false);
    const [startUploadSession] = useStartUploadSessionMutation();
    const [uploadChunk] = useUploadChunkMutation();
    const [finishUpload] = useFinishUploadMutation();
    const [afterValue, setAftervalue] = useState('');
    const [currentStep, setCurrentStep] = useState(0);
    const [activeGenerationType, setActiveGenerationType] = useState('');
    const [backgroundGenerationPrompt, setBackgroundGenerationPrompt] = useState('');
    const [creativeGenerationPrompt, setCreativeGenerationPrompt] = useState('');
    const [uploadedImage, setUploadedImage] = useState({});
    const [uploadType, setUploadType] = useState('');
    const [creativeGenerationResults, setCreativeGenerationResults] = useState([]);
    const [backgroundGenerationResults, setBackgroundGenerationResults] = useState([]);
    const [isCreativesGenerating, setIsCreativesGenerating] = useState(false);
    const [isBgCreativesGenerating, setBgIsCreativesGenerating] = useState(false);
    const [isBgLoading, setIsBgLoading] = useState(false);
    const [hasBgEdit, setBgHasEdit] = useState(false);
    const [hasVariationEdit, setVariationHasEdit] = useState(false);
    const [selectedBackgroundImages, setSelectedBackgroundImages] = useState([]);
    const [selectedCreativeImages, setSelectedCreativeImages] = useState([]);
    const [backgroundImageIds, setBackgroundImageIds] = useState([]);
    const [baseImage, setBaseImage] = useState(null);
    const [creativeFiles, setCreativeFiles] = useState([]);
    const [backgroundFiles, setBackgroundFiles] = useState([]);

    const { data: accountsCount } = useGetBmAdAccountsCountQuery();
    const totalCount = accountsCount?.summary?.total_count ?? 20;
    const isSearching = !!searchTerm?.trim();
    const effectivePageSize = isSearching ? String(totalCount) : "20";

    const { data: AdAccountData, refetch: refetchAdaccountData, isLoading: isAdAccountLoading, isFetching: isAdAccountFetching } = useGetBmAdAccountsQuery(
        {
            search: searchTerm ? searchTerm : '',
            pageSize: effectivePageSize,
            after: searchTerm ? '' : afterValue,
        },
        { skip: !isOpen }
    );

    const [generatePrompts, { isLoading: ispromptGenerating }] = useGeneratePromptMutation();
    const [generateCreativeVariations, { isLoading: isCreativesgenerating }] = useGenerateCreativeVariationsMutation();
    const [removeBackground, { isLoading: isBgremoving }] = useRemoveBackgroundMutation();
    const [generateBackgroundPrompt, { isLoading: isBgpromptGenerating }] = useGenerateBackgroundPromptMutation();
    const [generateBackgroundImages, { isLoading: isBgVariationsGenerating }] = useGenerateBackgroundImageMutation();

    const MAX_ATTEMPTS = 3;
    const POLL_INTERVAL = 2000; // 2 seconds

    const {
        data: backgroundImagesStatus,
        isLoading: isBgImagesGenerating,
        isSuccess,
        isError,
        refetch,
    } = useGetBackgroundImageStatusQuery(
        backgroundImageIds.length > 0 ? backgroundImageIds : skipToken
    );

    const attemptRef = useRef(1);

    useEffect(() => {
        let timeoutId;

        const shouldRetry = () => {
            if (!backgroundImagesStatus || backgroundImagesStatus.length === 0) return true;

            const validCount = backgroundImagesStatus.filter(item => item && item.id && item.url).length;
            return validCount < backgroundImageIds.length;
        };

        if (backgroundImagesStatus && isSuccess && baseImage) {
            const validData = backgroundImagesStatus.filter(item => item && item.id && item.url);

            if (shouldRetry() && attemptRef.current < MAX_ATTEMPTS) {
                timeoutId = setTimeout(() => {
                    attemptRef.current += 1;
                    refetch();
                }, POLL_INTERVAL);
            } else {
                // Final processing
                Promise.all(
                    validData.map(({ id, url }) =>
                        overlayImages(url, baseImage).then(compositedImage => ({ id, url: compositedImage }))
                    )
                ).then((compositedResults) => {
                    setBackgroundGenerationResults(compositedResults);
                    setBgIsCreativesGenerating(false);
                }).catch(() => {
                    setBackgroundGenerationResults(new Array(3).fill(null));
                    setBgIsCreativesGenerating(false);
                });
            }
        }

        if (isError) {
            setBackgroundGenerationResults(new Array(3).fill(null));
            setBgIsCreativesGenerating(false);
            toast({
                title: "Error",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top-right",
            });
        }

        return () => clearTimeout(timeoutId); // Cleanup on unmount
    }, [backgroundImagesStatus, isSuccess, isError, baseImage, backgroundImageIds.length]);


    useEffect(() => {
        if (hasSearched && searchTerm === '') {
            refetchAdaccountData();
        }
    }, [searchTerm]);

    // Formik setup
    const uploadFormik = useFormik({
        initialValues: {
            adsAccountName: [],
            files: [],
        },
        validationSchema: adUplaodSchema,
        onSubmit: async (values, { setSubmitting }) => {
            // Handle form submission
            if (values) {
                handleUploadAll(values.files);
                dispatch(setIsWidgetOpen(true));
                dispatch(setFiles([]));
                dispatch(setAfter(''));
                dispatch(setBefore(''));
                dispatch(setCurrentPage(0));
                localStorage.removeItem('after');
                localStorage.removeItem('before');
            }
            setSubmitting(false);
            uploadFormik.resetForm();
            onClose();
            localStorage.removeItem('selectedAdspressoAdsAccount');
            setSelectedAdAccounts([]);
            setAftervalue('');
        },
    });

    const onDrop = (acceptedFiles, rejectedFiles) => {

        if (rejectedFiles.length > 0) {
            toast({
                title: "Upload Error",
                description: "The uploaded file exceeds the maximum size limit.",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top-right",
            });
            return;
        }

        let validFile = null; // Use let instead of const

        for (const file of acceptedFiles) {
            if (file.type.startsWith("image/") && file.size > MAX_IMAGE_UPLOAD_SIZE_BYTES) {
                toast({
                    title: "Upload Error",
                    description: `The image ${file.name} exceeds the maximum size of 30 MB.`,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                    position: "top-right",
                });
            } else {
                validFile = {
                    name: file.name,
                    size: file.size,
                    creativeType: file.type,
                    url: URL.createObjectURL(file),
                    file: file,
                };
                break;
            }
        }

        if (validFile) {
            setUploadedImage(validFile);
            setUploadType('local-type');
            setBackgroundGenerationResults([]);
            setCreativeGenerationResults([]);
            setCreativeFiles([]);
            setBackgroundFiles([]);
            setBackgroundImageIds([]);
            setSelectedBackgroundImages([]);
        }
    };

    const handleMediaSelect = (file) => {
        if (file && file.length > 0) {
            setUploadedImage(file[0]);
            setUploadType('drive-type');
            setBackgroundGenerationResults([]);
            setCreativeGenerationResults([]);
            setCreativeFiles([]);
            setBackgroundFiles([]);
            setBackgroundImageIds([]);
            setSelectedBackgroundImages([]);
        }
        onDriveClose();
    };

    const handleAdaccountChange = (value) => {

        if (value) {
            // Check if the account is already selected
            const isAlreadySelected = selectedAdAccounts.some(
                (account) => account?.account_id === value?.account_id
            );
            if (isAlreadySelected) return;

            if (!isAlreadySelected) {
                // Prepare account details
                const accountDetails = {
                    ...value?.account,
                };

                // Add the account to the selectedAdAccounts state
                setSelectedAdAccounts((prevState) => {
                    const updatedAccounts = [accountDetails, ...prevState];

                    const accountNames = updatedAccounts.map(account => account.account_id);

                    uploadFormik.setFieldValue('adsAccountName', accountNames);
                    return updatedAccounts;
                });
            }
        }
    };

    const handleSearchChange = useCallback((value) => {
        setSearchTerm(value);
    }, []);

    // Function to remove an account from selectedAdAccounts
    const handleRemoveAdAccount = (accountId) => {
        // Remove the account from the selectedAdAccounts state
        setSelectedAdAccounts((prevState) => {
            const updatedAccounts = prevState.filter(account => account.account_id !== accountId);

            const accountNames = updatedAccounts.map(account => account.account_id);

            uploadFormik.setFieldValue('adsAccountName', accountNames);

            return updatedAccounts;
        });
    };


    const handleUploadAll = async (filesToUpload) => {
        // console.log((window.navigator.onLine ? 'on' : 'off') + 'line');

        window.addEventListener('online', () => {
            toast({
                title: "You are back online!",
                status: "success",
                duration: 4000,
                isClosable: true,
                position: "top-right",
            });
        });

        window.addEventListener('offline', () => {
            toast({
                title: "You are offline. Some functionality may be unavailable.",
                status: "error",
                duration: 4000,
                isClosable: true,
                position: "top-right",
            });
        });

        const uploadPromises = [];

        for (const file of filesToUpload) {
            const adsAccountsArray = uploadFormik?.values?.adsAccountName.map(accountId => {
                const selectedAdAccount = selectedAdAccounts?.find(account => account?.account_id === accountId);
                return selectedAdAccount ? {
                    id: selectedAdAccount?._id,
                    adsAccountId: selectedAdAccount?.account_id,
                    adsAccountName: selectedAdAccount?.name,
                    businessName: selectedAdAccount?.business?.name,
                    businessId: selectedAdAccount?.business?.id,
                } : null;
            }).filter(account => account !== null);
            if (adsAccountsArray.length === 0) {
                toast({
                    title: "Account Error",
                    description: "Please select a valid Ads Account.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                    position: "top-right",
                });
                return;
            }

            if (file.type.startsWith("image/")) {
                const uploadImagePromise = (async () => {
                    const formData = new FormData();
                    formData.append('filename', file.file);
                    formData.append('aiGenerated', true);
                    formData.append('adsAccounts', JSON.stringify(adsAccountsArray));

                    let progressInterval;

                    try {
                        const uploadDuration = 3000;
                        const interval = 100;
                        const totalSteps = uploadDuration / interval;

                        let progress = 0;
                        progressInterval = setInterval(() => {
                            if (progress < 100) {
                                progress += Math.round(100 / totalSteps);
                                adsAccountsArray.forEach(account => {
                                    dispatch(updateUploadStatus({ fileName: file.name, accountId: account.adsAccountId, accountName: account.adsAccountName, status: "uploading", progress }));
                                });
                            }
                        }, interval);

                        const response = await uploadImage({ payload: formData }).unwrap();
                        // Check if the response contains a "File already exist" message
                        const fileExists = response?.data?.some(item => item?.message === "File already exist");

                        if (fileExists) {
                            toast({
                                title: "Upload Error",
                                description: "File already exists",
                                status: "error",
                                duration: 5000,
                                isClosable: true,
                                position: "top-right",
                            });

                            // Dispatch failed status for the upload
                            adsAccountsArray.forEach(account => {
                                dispatch(updateUploadStatus({
                                    fileName: file.name,
                                    accountId: account.adsAccountId,
                                    accountName: account.adsAccountName,
                                    status: "failed",
                                    progress: 0,
                                }));
                            });
                        } else {
                            // If no error
                            onSuccess();

                            // Update status to "done" for each account
                            adsAccountsArray.forEach(account => {
                                dispatch(updateUploadStatus({
                                    fileName: file.name,
                                    accountId: account.adsAccountId,
                                    accountName: account.adsAccountName,
                                    status: "done",
                                    progress: 100,
                                }));
                            });
                        }

                        // Clear the interval regardless of success or failure
                        clearInterval(progressInterval);
                    } catch (error) {
                        clearInterval(progressInterval);
                        adsAccountsArray.forEach(account => {
                            dispatch(updateUploadStatus({ fileName: file.name, accountId: account.adsAccountId, accountName: account.adsAccountName, status: "failed", progress: 0 }));
                        });
                        toast({
                            title: "Upload Error",
                            description: error?.data?.message,
                            status: "error",
                            duration: 5000,
                            isClosable: true,
                            position: "top-right",
                        });
                    }
                })();

                uploadPromises.push(uploadImagePromise);
            }
        }

        // Wait for all uploads to complete
        await Promise.all(uploadPromises);
    };

    const handleNext = () => {
        setCurrentStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setCurrentStep((prevStep) => prevStep - 1);
    };

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        open
    } = useDropzone({
        onDrop,
        accept: {
            "image/*": [".png", ".jpg", ".jpeg"]
        },
        multiple: true,
        maxFiles: 50,
        maxSize: MAX_IMAGE_UPLOAD_SIZE_BYTES,
        disabled: !uploadFormik.values.adsAccountName.length,
        noClick: true,
    });

    const showAdAccountError = !uploadFormik.values.adsAccountName.length;

    const handleModalClose = () => {
        uploadFormik.resetForm();
        dispatch(setFiles([]));
        onClose();
        localStorage.removeItem('selectedAdspressoAdsAccount');
        setSelectedAdAccounts([]);
        setAftervalue('');
        setCurrentStep(0);
    };

    const handleLoadMore = (after) => {
        setAftervalue(after);
    };

    const handleGenerationSelect = (val) => {

        setActiveGenerationType(val);

        if (isCreativesGenerating || isBgCreativesGenerating) return;

        if (val === 'creative-variation') {
            if (creativeGenerationResults?.length > 0) return;

            const formData = new FormData();
            if (uploadType === 'drive-type') {
                formData.append('image_url', uploadedImage?.url);
            } else {
                formData.append('filename', uploadedImage?.file);
            }

            setIsCreativesGenerating(true);
            setCreativeGenerationResults(new Array(3).fill(undefined)); // Fill 3 placeholders

            generatePrompts(formData)
                .unwrap()
                .then(async (response) => {
                    setCreativeGenerationPrompt(response?.data);

                    const promptFormData = new FormData();
                    if (uploadType === 'drive-type') {
                        promptFormData.append('image_url', uploadedImage?.url);
                    } else {
                        promptFormData.append('filename', uploadedImage?.file);
                    }
                    promptFormData.append('prompt', response?.data);

                    const requests = Array.from({ length: 3 }).map((_, index) =>
                        generateCreativeVariations(promptFormData)
                            .unwrap()
                            .then(res => {
                                const image = res?.data?.image ? `data:image/png;base64,${res.data.image}` : null;
                                setCreativeGenerationResults(prev => {
                                    const updated = [...prev];
                                    updated[index] = image;
                                    return updated;
                                });
                            })
                            .catch(() => {
                                setCreativeGenerationResults(prev => {
                                    const updated = [...prev];
                                    updated[index] = null;
                                    return updated;
                                });
                            })
                    );

                    // Wait for all requests to complete before marking generation as done
                    await Promise.allSettled(requests);
                    setIsCreativesGenerating(false);

                })
                .catch((error) => {
                    setIsCreativesGenerating(false);
                    toast({
                        position: "top-right",
                        title: "Error",
                        description: error?.data?.message,
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                });

        } else if (val === 'background-variation') {
            if (backgroundGenerationResults?.length > 0) return;

            const formData = new FormData();
            if (uploadType === 'drive-type') {
                formData.append('url', uploadedImage?.url);
            } else {
                formData.append('image', uploadedImage?.file);
            }

            setIsBgLoading(true);
            setBgIsCreativesGenerating(true);
            setBackgroundImageIds([]);
            attemptRef.current = 1;
            setBackgroundGenerationResults(new Array(3).fill(undefined)); // Fill 3 placeholders

            removeBackground(formData)
                .unwrap()
                .then(async (response) => {
                    const base64Image = `data:image/png;base64,${response.data.image}`;
                    setBaseImage(base64Image); // <- store base image for overlay
                    const file = base64ToFile(base64Image, undefined, 'image/png');
                    const formData = new FormData();
                    formData.append('filename', file);

                    generateBackgroundPrompt(formData)
                        .unwrap()
                        .then(async (response) => {
                            setBackgroundGenerationPrompt(response?.data);
                            setIsBgLoading(false);

                            const payload = { prompt: response?.data };

                            // Launch 3 parallel calls to generateBackgroundImages
                            const requests = Array.from({ length: 3 }, () =>
                                generateBackgroundImages(payload).unwrap()
                            );

                            // Use allSettled to handle each response independently
                            const settledResponses = await Promise.allSettled(requests);

                            // Collect image IDs from successful responses
                            const imageIds = settledResponses
                                .filter(result => result.status === 'fulfilled' && result.value?.data?.id)
                                .map(result => result.value.data.id); // Get the id directly

                            setBackgroundImageIds(imageIds);
                            setBgIsCreativesGenerating(false);
                            onSuccess();
                        })
                        .catch((error) => {
                            // console.error('Prompt generation error:', error);
                            setBgIsCreativesGenerating(false);
                            onSuccess();
                            setIsBgLoading(false);
                            toast({
                                position: "top-right",
                                title: "Error",
                                description: error?.data?.message,
                                status: "error",
                                duration: 4000,
                                isClosable: true,
                            });
                        });
                })
                .catch((error) => {
                    // console.error('Background generation error:', error);
                    setBgIsCreativesGenerating(false);
                    setIsBgLoading(false);
                    toast({
                        position: "top-right",
                        title: "Error",
                        description: error?.data?.message,
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                });
        }
    };

    const handleGeneration = (type) => {
        if (type === 'background-variation') {
            handleRemoveBackground(type);
        } else if (type === 'creative-variation') {
            handleGenerateBackground(type);
        }
    }

    const handleRemoveBackground = async (type) => {

        if (type === 'background-variation') {

            const formData = new FormData();
            if (uploadType === 'drive-type') {
                formData.append('url', uploadedImage?.url);
            } else {
                formData.append('image', uploadedImage?.file);
            }

            setBackgroundImageIds([]); // <-- Clear old image IDs
            attemptRef.current = 1;    // <-- Reset retry count
            setBgIsCreativesGenerating(true);
            setBackgroundGenerationResults(new Array(3).fill(undefined)); // Fill 3 placeholders

            const payload = {
                prompt: backgroundGenerationPrompt,
            }

            // Launch 3 parallel calls to generateBackgroundImages
            const requests = Array.from({ length: 3 }, () =>
                generateBackgroundImages(payload).unwrap()
            );

            // Use allSettled to handle each response independently
            const settledResponses = await Promise.allSettled(requests);

            // Collect image IDs from successful responses
            const imageIds = settledResponses
                .filter(result => result.status === 'fulfilled' && result.value?.data?.id)
                .map(result => result.value.data.id); // Get the id directly

            setBackgroundImageIds(imageIds);

        }
    };

    const handleGenerateBackground = async (type) => {

        setIsCreativesGenerating(true);
        setCreativeGenerationResults(new Array(3).fill(undefined)); // Fill 3 placeholders

        if (type === 'creative-variation') {

            const promptFormData = new FormData();
            if (uploadType === 'drive-type') {
                promptFormData.append('image_url', uploadedImage?.url);
            } else {
                promptFormData.append('filename', uploadedImage?.file);
            }
            promptFormData.append('prompt', creativeGenerationPrompt);

            const requests = Array.from({ length: 3 }).map((_, index) =>
                generateCreativeVariations(promptFormData)
                    .unwrap()
                    .then(res => {
                        const image = res?.data?.image ? `data:image/png;base64,${res.data.image}` : null;
                        setCreativeGenerationResults(prev => {
                            const updated = [...prev];
                            updated[index] = image;
                            return updated;
                        });
                    })
                    .catch(() => {
                        setCreativeGenerationResults(prev => {
                            const updated = [...prev];
                            updated[index] = null;
                            return updated;
                        });
                    })
            );

            // Wait for all requests to complete before marking generation as done
            await Promise.allSettled(requests);
            setIsCreativesGenerating(false);
            onSuccess();

        }
    };

    const processCreativeBase64ToFiles = (base64Images, uploadedImage) => {
        if (!uploadedImage?.name) return [];

        const refName = uploadedImage.name.split(".")[0];
        const timestamp = Date.now();

        return base64Images
            .filter(Boolean)
            .map((base64, index) => {
                const fileName = `${refName}${timestamp}_${index + 1}.png`;
                const file = base64ToFile(base64, fileName, 'image/png');

                return {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    file: file,
                    thumbnail: base64,
                    status: 'pending',
                    progress: 0,
                };
            });
    };


    const processImagesToFiles = async (urls, uploadedImage) => {
        if (!uploadedImage?.name) return [];

        const refName = uploadedImage.name.split(".")[0];
        const timestamp = Date.now();

        return await Promise.all(
            urls.map(async (url, index) => {
                const fileName = `${refName}${timestamp}_${index + 1}.png`;
                const file = await urlToFile(url, fileName, 'image/png');

                return {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    file: file,
                    thumbnail: url,
                    status: 'pending',
                    progress: 0,
                };
            })
        );
    };

    const updateCombinedFiles = (newCreativeFiles = creativeFiles, newBackgroundFiles = backgroundFiles) => {
        const combined = [...newCreativeFiles, ...newBackgroundFiles];
        dispatch(setFiles(combined));
        uploadFormik.setFieldValue("files", combined);
    };


    const handleBackgroundCheckboxChange = async (url) => {
        const updatedSelection = selectedBackgroundImages.includes(url)
            ? selectedBackgroundImages.filter((item) => item !== url)
            : [...selectedBackgroundImages, url];

        setSelectedBackgroundImages(updatedSelection);

        const processedImages = await processImagesToFiles(updatedSelection, uploadedImage);
        setBackgroundFiles(processedImages);
        updateCombinedFiles(creativeFiles, processedImages);
    };

    const handleSelectAllBackgrounds = async () => {
        const validResults = backgroundGenerationResults.filter(res => res !== null && res !== undefined);

        let updatedSelection = [];

        if (selectedBackgroundImages.length === validResults.length) {
            updatedSelection = [];
        } else {
            updatedSelection = validResults.map(item => item.url);
        }

        setSelectedBackgroundImages(updatedSelection);

        const processedImages = await processImagesToFiles(updatedSelection, uploadedImage);
        setBackgroundFiles(processedImages);
        updateCombinedFiles(creativeFiles, processedImages);
    };


    const handleCreativeCheckboxChange = (url) => {
        const updatedSelection = selectedCreativeImages.includes(url)
            ? selectedCreativeImages.filter((item) => item !== url)
            : [...selectedCreativeImages, url];

        setSelectedCreativeImages(updatedSelection);

        const processedImages = processCreativeBase64ToFiles(updatedSelection, uploadedImage);
        setCreativeFiles(processedImages);
        updateCombinedFiles(processedImages, backgroundFiles);
    };

    const handleSelectAllCreatives = () => {
        let updatedSelection = [];

        if (selectedCreativeImages.length === creativeGenerationResults.length) {
            updatedSelection = [];
        } else {
            updatedSelection = creativeGenerationResults.filter(Boolean); // Remove any undefined/null
        }

        setSelectedCreativeImages(updatedSelection);

        const processedImages = processCreativeBase64ToFiles(updatedSelection, uploadedImage);
        setCreativeFiles(processedImages);
        updateCombinedFiles(processedImages, backgroundFiles);
    };

    return (
        <>
            {/* Drive Modal */}
            <ReplaceDriveModal
                isDriveModalOpen={isDriveOpen}
                selectedAdAccounts={
                    selectedAdAccounts?.map(account => ({
                        id: account?.id,
                        adsAccountId: account?.account_id,
                        adsAccountName: account?.name
                    }))
                }
                onClose={onDriveClose}
                onSubmit={handleMediaSelect}
                uploadPurpose="update"
                mediaType={'image'}
            />

            <Modal isOpen={isOpen} onClose={() => handleModalClose()} size={{ base: "6xl" }} scrollBehavior="inside" closeOnOverlayClick={false} closeOnEsc={false}>
                <ModalOverlay />
                <ModalContent minH="70vh">
                    <ModalHeader>
                        <ModalCloseButton />
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                    <Text>AI Image Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                            <Text fontWeight={'bold'}>Generated with AI</Text>
                                            <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <Divider mb={'10px'} />
                    <ModalBody>

                        <Flex direction={'row'} minH={'50vh'}>

                            {currentStep === 0 && (
                                <>
                                    <Box flex={'40%'} maxH="400px" p={2}>

                                        {/* Display chosen accounts */}
                                        <Text mb={2} fontWeight={"bold"}>
                                            Choose Ad Accounts
                                        </Text>
                                        <Text fontSize={'12px'} mb={2}>
                                            The AI-generated image will be saved only to the My Drive of the Ad Accounts you select below
                                        </Text>

                                        <SearchAdaccountAdspresso
                                            onInitialisation={() => { }}
                                            accountOptions={AdAccountData?.data}
                                            onAccountChange={handleAdaccountChange}
                                            onSearchInputChange={handleSearchChange}
                                            onSearchInputTouched={setHasSearched}
                                            AdsAccountIdFromParams={''}
                                            isAdAccountLoading={isAdAccountLoading}
                                            isAdAccountFetching={isAdAccountFetching}
                                            pageMeta={AdAccountData?.meta}
                                            onLoadMore={handleLoadMore}
                                            selectedAccounts={selectedAdAccounts}
                                            onRemoveAccount={handleRemoveAdAccount}
                                            isForStatusUpload={true}
                                        />
                                    </Box>

                                    <Box flex={'2%'} maxH="400px">
                                        <Divider orientation='vertical' />
                                    </Box>

                                    <Box flex={'58%'} maxH="400px" p={2} overflowY="auto">
                                        <Text mb={2} fontWeight={"bold"}>
                                            Selected Ad Accounts
                                        </Text>

                                        <Stack spacing={1} mt={2}>
                                            {selectedAdAccounts?.map((account, index) => (
                                                <Flex key={`${account?.account_id}-${index}`} align="center" direction="row">
                                                    {/* Account name and account ID with currency on separate lines */}
                                                    <Flex direction="column" align="flex-start" flex={0.9} p={1}>
                                                        <Text fontSize="12px">
                                                            {account?.name?.length > 48
                                                                ? `${account.name.substring(0, 48)}...`
                                                                : account?.name}
                                                        </Text>
                                                        <Flex gap={"5px"}>
                                                            <Text fontSize="11px" color="gray.500">
                                                                {account?.account_id}
                                                            </Text>
                                                        </Flex>
                                                    </Flex>

                                                    {/* Remove button */}
                                                    <Flex justify="flex-end" flex={0.1}>
                                                        <Tooltip label="Remove" aria-label="Remove account tooltip" fontSize={'12px'}>
                                                            <IconButton
                                                                icon={<CloseIcon />}
                                                                size="sm"
                                                                variant="ghost"
                                                                colorScheme="red"
                                                                onClick={() => handleRemoveAdAccount(account.account_id)}
                                                                aria-label="Remove account"
                                                            />
                                                        </Tooltip>
                                                    </Flex>
                                                </Flex>
                                            ))}
                                        </Stack>
                                    </Box>
                                </>
                            )}

                            {currentStep === 1 && (
                                <>
                                    <Box flex={'33%'} maxH="480px" >
                                        <Flex direction={'column'} pr={'10px'}>
                                            <Text fontWeight={"bold"} fontSize={'lg'} mb={'10px'}>
                                                Generation Setup
                                            </Text>

                                            <FormControl mb={'20px'} display={'flex'} flexDirection={'row'} alignItems={'flex-end'} gap={'10px'}>
                                                {uploadedImage && Object.keys(uploadedImage).length > 0 ? (
                                                    <Flex align="flex-end" gap={4}>
                                                        <Flex direction={'column'} gap={2}>
                                                            <Image
                                                                src={uploadedImage?.url}
                                                                alt={uploadedImage?.name}
                                                                objectFit="cover"
                                                                width="100px"
                                                                height="100px"
                                                                borderRadius="3px"
                                                            />
                                                            <Text fontSize={'12px'} color="gray">{truncateName(uploadedImage?.name, 10)}</Text>
                                                        </Flex>
                                                        <Flex direction="column" gap={1}>
                                                            <Text fontSize="12px" fontWeight="medium" color={textColor}>
                                                                Replace from
                                                            </Text>

                                                            <Flex align="center" gap={2}>
                                                                <Button
                                                                    onClick={() => {
                                                                        onDriveOpen();
                                                                        setCreativeGenerationPrompt('');
                                                                        setActiveGenerationType('');
                                                                        setBackgroundGenerationResults([]);
                                                                        setCreativeGenerationResults([]);
                                                                    }}
                                                                    isDisabled={isCreativesGenerating || isBgCreativesGenerating}
                                                                    variant="link"
                                                                    p={0}
                                                                >
                                                                    <Text fontSize="12px" color={textColor}>My Drive</Text>
                                                                </Button>

                                                                <Text fontSize="12px" color={textColor}>or</Text>

                                                                <Button
                                                                    onClick={() => {
                                                                        setCreativeGenerationPrompt('');
                                                                        setActiveGenerationType('');
                                                                        setBackgroundGenerationResults([]);
                                                                        setCreativeGenerationResults([]);

                                                                        setTimeout(() => {
                                                                            open();
                                                                        }, 0);
                                                                    }}
                                                                    isDisabled={isCreativesGenerating || isBgCreativesGenerating}
                                                                    variant="link"
                                                                    p={0}
                                                                >
                                                                    <Text fontSize="12px" color={textColor}>Device</Text>
                                                                </Button>
                                                            </Flex>
                                                        </Flex>
                                                    </Flex>
                                                ) : (
                                                    <Center
                                                        className="dropzone"
                                                        {...getRootProps({ disabled: showAdAccountError })}
                                                        sx={{
                                                            textAlign: 'center',
                                                            borderWidth: '1px',
                                                            borderColor: 'gray.600',
                                                            borderStyle: 'dashed',
                                                            background: backgroundColor,
                                                            borderRadius: 10,
                                                            minHeight: '120px',
                                                            w: '100%',
                                                            cursor: showAdAccountError ? 'not-allowed' : 'default',
                                                            opacity: showAdAccountError ? 0.6 : 1,
                                                        }}
                                                        borderColor={isDragActive ? 'gray.500' : 'gray.600'}
                                                    >
                                                        <Input {...getInputProps()} />
                                                        <Flex flexDirection={'column'}>
                                                            <Text fontSize={'14px'}>Select from</Text>
                                                            <Link textDecoration={'underline'} color={textColor} onClick={() => {
                                                                onDriveOpen();
                                                                setUploadType('drive-type')
                                                            }} fontSize={'14px'}>
                                                                My Drive
                                                            </Link>
                                                            <Text fontSize={'14px'}>or</Text>
                                                            <Link textDecoration={'underline'} color={textColor} onClick={() => {
                                                                open();
                                                                setUploadType('local-type')
                                                            }} fontSize={'14px'}>
                                                                Device
                                                            </Link>
                                                        </Flex>
                                                    </Center>
                                                )}
                                            </FormControl>

                                            <RadioGroup
                                                mb={'20px'}
                                                colorScheme="brand"
                                                value={activeGenerationType}
                                                onChange={setActiveGenerationType}
                                                isDisabled={!uploadedImage || Object.keys(uploadedImage).length === 0}
                                            >
                                                <Flex direction="column" gap="20px">
                                                    {/* Background Variation */}
                                                    <Box>
                                                        <Flex gap="10px" alignItems={'center'}>
                                                            <Radio bg="#fff" value="background-variation">
                                                                <Text fontSize="16px" fontWeight="bold">Background Variation</Text>
                                                            </Radio>
                                                            <Tooltip
                                                                borderRadius={5}
                                                                label={
                                                                    <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                                                        <Text fontWeight={'bold'}>Background Variation</Text>
                                                                        <Text>To generate images featuring a specific object in different environments, product image must have a solid or transparent background so that the product image is clear and distinct.
                                                                            Should not contain text, partial objects or additional design elements
                                                                            File format in JPEG or PNG recommended
                                                                            File size no greater than 3,000 x 3,000 (minimum 320 x 320)</Text>
                                                                    </Flex>
                                                                }
                                                                fontSize="md"
                                                            >
                                                                <InfoOutlineIcon pointerEvents="all" />
                                                            </Tooltip>
                                                        </Flex>
                                                        {activeGenerationType === 'background-variation' && hasBgEdit && !isBgLoading && (
                                                            <Flex pl="25px" direction="column">
                                                                <Text fontSize="12px" mb="5px">Edit Prompt</Text>
                                                                <Textarea
                                                                    fontSize={'12px'}
                                                                    value={backgroundGenerationPrompt}
                                                                    onChange={(e) => setBackgroundGenerationPrompt(e.target.value)}
                                                                    placeholder="Enter your prompt here"
                                                                    isDisabled={!hasBgEdit || isBgLoading}
                                                                />
                                                            </Flex>
                                                        )}
                                                    </Box>

                                                    {/* Creative Variation */}
                                                    <Box>
                                                        <Flex gap="10px" alignItems={'center'}>
                                                            <Radio bg="#fff" value="creative-variation">
                                                                <Text fontSize="16px" fontWeight="bold">Creative Variation</Text>
                                                            </Radio>
                                                            <Tooltip
                                                                borderRadius={5}
                                                                label={
                                                                    <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                                                        <Text fontWeight={'bold'}>Creative Variation</Text>
                                                                        <Text>This setting generates entirely new images using AI, including both the product and the setting it’s placed in. It allows AI to reinterpret the creative from scratch, offering a fresh, AI-designed visual.</Text>
                                                                        <Text>Great when you want to explore completely new creative directions or don't have a specific product image as a base.</Text>
                                                                    </Flex>
                                                                }
                                                                fontSize="md"
                                                            >
                                                                <InfoOutlineIcon pointerEvents="all" />
                                                            </Tooltip>
                                                        </Flex>
                                                        {activeGenerationType === 'creative-variation' && hasVariationEdit && !isCreativesGenerating && (
                                                            <Flex pl="25px" direction="column">
                                                                <Text fontSize="12px" mb="5px">Edit Prompt</Text>
                                                                <Textarea
                                                                    fontSize={'12px'}
                                                                    value={creativeGenerationPrompt}
                                                                    onChange={(e) => setCreativeGenerationPrompt(e.target.value)}
                                                                    placeholder="Enter your prompt here"
                                                                    isDisabled={!hasVariationEdit || isCreativesGenerating}
                                                                />
                                                            </Flex>
                                                        )}
                                                    </Box>
                                                </Flex>
                                            </RadioGroup>

                                            <Flex direction="column" gap={4}>
                                                {(activeGenerationType === 'creative-variation') ? (
                                                    <Button
                                                        size="md"
                                                        colorScheme="brand"
                                                        width="100%"
                                                        isDisabled={
                                                            !uploadedImage || Object.keys(uploadedImage).length === 0 ||
                                                            isCreativesgenerating || isBgCreativesGenerating ||
                                                            (!hasVariationEdit && creativeGenerationResults?.length > 0)
                                                        }
                                                        onClick={() =>
                                                            hasVariationEdit
                                                                ? handleGeneration(activeGenerationType)
                                                                : handleGenerationSelect(activeGenerationType)
                                                        }
                                                    >
                                                        Generate
                                                    </Button>
                                                ) : activeGenerationType === 'background-variation' ? (
                                                    <Button
                                                        size="md"
                                                        colorScheme="brand"
                                                        width="100%"
                                                        isDisabled={
                                                            !uploadedImage || Object.keys(uploadedImage).length === 0 ||
                                                            isCreativesgenerating || isBgCreativesGenerating ||
                                                            (!hasBgEdit && backgroundGenerationResults?.length > 0)
                                                        }
                                                        onClick={() =>
                                                            hasBgEdit
                                                                ? handleGeneration(activeGenerationType)
                                                                : handleGenerationSelect(activeGenerationType)
                                                        }
                                                    >
                                                        Generate
                                                    </Button>
                                                ) :
                                                    <Button
                                                        size="md"
                                                        colorScheme="brand"
                                                        width="100%"
                                                        isDisabled
                                                    >
                                                        Generate
                                                    </Button>
                                                }
                                            </Flex>

                                        </Flex>
                                    </Box>

                                    <Box flex={'2%'} maxH="400px">
                                        <Divider orientation='vertical' />
                                    </Box>

                                    <Box flex={'65%'} maxH="400px" >
                                        <Flex flexDirection={'column'}>
                                            {activeGenerationType == '' ? (
                                                null
                                            ) : null}

                                            {activeGenerationType === 'background-variation' ? (
                                                <>
                                                    {isBgLoading ? (
                                                        <Flex direction={"column"} alignItems="center" justifyContent="center" h="50vh">
                                                            <Image
                                                                src="/Ai_ImageLoader.gif"
                                                                alt="Image Generation Steps"
                                                                boxSize="200px"
                                                                objectFit="contain"
                                                                width={"100%"}
                                                            />
                                                            <Flex direction={"column"} alignItems={"center"} gap={2}>
                                                                <Text fontWeight={"bold"} fontSize={"14px"}>
                                                                AI generating variations...
                                                                </Text>
                                                                <Text fontSize={"14px"}>This step may take up to a minute</Text>
                                                            </Flex>
                                                        </Flex>
                                                    ) : (
                                                        <>
                                                            {backgroundGenerationResults?.length > 0 ? (
                                                                <>
                                                                    <Box>
                                                                        <Text fontWeight={'bold'} >AI Generated Results</Text>
                                                                        <Text fontSize={'12px'}>Select at least one to proceed for use</Text>
                                                                    </Box>
                                                                    <Flex justifyContent={'flex-end'}>
                                                                        <Checkbox
                                                                            colorScheme="brand"
                                                                            size="sm"
                                                                            variant={"solid"}
                                                                            fontSize={'12px'}
                                                                            isDisabled={isBgCreativesGenerating}
                                                                            isChecked={
                                                                                selectedBackgroundImages.length > 0 &&
                                                                                selectedBackgroundImages.length ===
                                                                                backgroundGenerationResults.filter((res) => res !== null && res !== undefined).length
                                                                            }
                                                                            onChange={() => handleSelectAllBackgrounds()}
                                                                        >
                                                                            Select All
                                                                        </Checkbox>
                                                                    </Flex>

                                                                    <Flex
                                                                        flexDirection="row"
                                                                        gap="10px"
                                                                        mt="10px"
                                                                        flexWrap="wrap"
                                                                    >
                                                                        {Array.from({ length: 3 }).map((_, index) => {
                                                                            const result = backgroundGenerationResults[index];
                                                                            const isLoading = isBgCreativesGenerating && result === undefined;
                                                                            const isFailed = result === null;

                                                                            return (
                                                                                <Box
                                                                                    key={index}
                                                                                    role="group"
                                                                                    borderWidth="1px"
                                                                                    borderRadius="md"
                                                                                    overflow="hidden"
                                                                                    p="2px"
                                                                                    width="170px"
                                                                                    height="170px"
                                                                                    position="relative"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                    bg="gray.50"
                                                                                >
                                                                                    {isLoading ? (
                                                                                        <Skeleton width="100%" height="160px" />
                                                                                    ) : isFailed ? (
                                                                                        <Text fontSize="12px" color="red.500" textAlign="center">
                                                                                            Failed to generate
                                                                                        </Text>
                                                                                    ) : result ? (
                                                                                        <>
                                                                                            <Image
                                                                                                src={result.url}
                                                                                                alt={`Generated Image ${index + 1}`}
                                                                                                objectFit="cover"
                                                                                                width="100%"
                                                                                                height="160px"
                                                                                                borderRadius="3px"
                                                                                            />
                                                                                            <Checkbox
                                                                                                position="absolute"
                                                                                                top="5px"
                                                                                                right="5px"
                                                                                                bg="#fff"
                                                                                                isDisabled={isBgCreativesGenerating}
                                                                                                isChecked={selectedBackgroundImages.includes(result.url)}
                                                                                                onChange={() => handleBackgroundCheckboxChange(result.url)}
                                                                                                colorScheme="brand"
                                                                                                border="1px"
                                                                                                borderColor="gray.50"
                                                                                            />
                                                                                            <Box
                                                                                                position="absolute"
                                                                                                bottom="5px"
                                                                                                left="5px"
                                                                                                opacity="0"
                                                                                                _groupHover={{ opacity: 1 }}
                                                                                                zIndex="2"
                                                                                                bg="#fff"
                                                                                                borderRadius="sm"
                                                                                            >
                                                                                                <Tooltip
                                                                                                    label={<Image src={result.url} width="300px" />}
                                                                                                    bg="gray.50"
                                                                                                    p="1"
                                                                                                >
                                                                                                    <Box>
                                                                                                        <IconButton
                                                                                                            aria-label="Preview Image"
                                                                                                            icon={<FiEye />}
                                                                                                            size="xs"
                                                                                                            variant="ghost"
                                                                                                            color={"gray.600"}
                                                                                                            _hover={{
                                                                                                                background: 'none',
                                                                                                            }}
                                                                                                        />
                                                                                                    </Box>
                                                                                                </Tooltip>
                                                                                            </Box>
                                                                                        </>
                                                                                    ) : null}
                                                                                </Box>
                                                                            );
                                                                        })}
                                                                    </Flex>

                                                                    <Box mt={'20px'}>
                                                                        <Box mb={'10px'}>
                                                                            <Text fontWeight={'bold'} fontSize={'12px'}>Like what you see but not sure yet?</Text>
                                                                            <Text fontSize={'12px'}>Click Generate to see more similar backgrounds.</Text>
                                                                        </Box>
                                                                        <Box cursor={isBgCreativesGenerating || isCreativesGenerating ? "not-allowed" : "pointer"}>
                                                                            <Text fontWeight="bold" fontSize="12px">
                                                                                Don't like the results?
                                                                            </Text>
                                                                            <Text fontSize="12px">
                                                                                Click{" "}
                                                                                <Link
                                                                                    onClick={() => {
                                                                                        if (!isBgCreativesGenerating) {
                                                                                            setBgHasEdit(true);
                                                                                        }
                                                                                    }}
                                                                                    fontWeight="bold"
                                                                                    color={isBgCreativesGenerating || isCreativesGenerating ? "gray.400" : "none"}
                                                                                    _hover={{ textDecoration: isBgCreativesGenerating || isCreativesGenerating ? "none" : "underline" }}
                                                                                    pointerEvents={isBgCreativesGenerating || isCreativesGenerating ? "none" : "auto"}
                                                                                >
                                                                                    here
                                                                                </Link>{" "}
                                                                                to edit the prompt based on your requirements and click Generate.
                                                                            </Text>
                                                                        </Box>
                                                                    </Box>
                                                                </>
                                                            ) :
                                                                // <Flex>
                                                                //      <Text fontSize={'14px'}>No images could be generated for this request. Please replace the other image and generating again.</Text>
                                                                // </Flex>
                                                                null
                                                            }
                                                        </>
                                                    )}
                                                </>
                                            ) : null}

                                            {activeGenerationType === 'creative-variation' ? (
                                                <>
                                                    {isCreativesGenerating && (creativeGenerationResults || []).every(res => res === undefined) ?
                                                        (
                                                            <Flex direction={'column'} alignItems="center" justifyContent="center" h="50vh">
                                                                <Image
                                                                    src="/Ai_ImageLoader.gif"
                                                                    alt="Image Generation Steps"
                                                                    boxSize="200px"
                                                                    objectFit="contain"
                                                                    width={"100%"}
                                                                />
                                                                <Flex direction={"column"} alignItems={"center"} gap={2}>
                                                                    <Text fontWeight={"bold"} fontSize={"14px"}>
                                                                    AI generating variations...
                                                                    </Text>
                                                                    <Text fontSize={"14px"}>This step may take 2 to 3 minutes</Text>
                                                                </Flex>
                                                            </Flex>
                                                        ) : (
                                                            <>
                                                                {creativeGenerationResults.length > 0 ? (
                                                                    <>
                                                                        <Box>
                                                                            <Text fontWeight="bold">AI Generated Results</Text>
                                                                            <Text fontSize="12px">Select at least one to proceed for use</Text>
                                                                        </Box>

                                                                        <Flex justifyContent="flex-end" mb="10px">
                                                                            <Checkbox
                                                                                colorScheme="brand"
                                                                                size="sm"
                                                                                variant="solid"
                                                                                fontSize="12px"
                                                                                isDisabled={isCreativesgenerating}
                                                                                isChecked={
                                                                                    selectedCreativeImages.length > 0 &&
                                                                                    selectedCreativeImages.length ===
                                                                                    creativeGenerationResults.filter((res) => res !== null).length
                                                                                }
                                                                                onChange={handleSelectAllCreatives}
                                                                            >
                                                                                Select All
                                                                            </Checkbox>
                                                                        </Flex>

                                                                        <Flex
                                                                            flexDirection="row"
                                                                            gap="10px"
                                                                            mt="10px"
                                                                            flexWrap="wrap"
                                                                        >
                                                                            {Array.from({ length: 3 }).map((_, index) => {
                                                                                const result = creativeGenerationResults[index];
                                                                                const isLoading = isCreativesGenerating && result === undefined;
                                                                                const isFailed = result === null;

                                                                                return (
                                                                                    <Box
                                                                                        key={index}
                                                                                        role="group"
                                                                                        borderWidth="1px"
                                                                                        borderRadius="md"
                                                                                        overflow="hidden"
                                                                                        p="2px"
                                                                                        width="170px"
                                                                                        height="170px"
                                                                                        position="relative"
                                                                                        display="flex"
                                                                                        alignItems="center"
                                                                                        justifyContent="center"
                                                                                        bg="gray.50"
                                                                                    >
                                                                                        {isLoading ? (
                                                                                            <Skeleton width="100%" height="160px" />
                                                                                        ) : isFailed ? (
                                                                                            <Text fontSize="12px" color="red.500" textAlign="center">
                                                                                                Failed to generate
                                                                                            </Text>
                                                                                        ) : result ? (
                                                                                            <>
                                                                                                <Image
                                                                                                    src={result}
                                                                                                    alt={`Generated Image ${index + 1}`}
                                                                                                    objectFit="cover"
                                                                                                    width="100%"
                                                                                                    height="160px"
                                                                                                    borderRadius="3px"
                                                                                                />
                                                                                                <Checkbox
                                                                                                    position="absolute"
                                                                                                    top="5px"
                                                                                                    right="5px"
                                                                                                    bg="#fff"
                                                                                                    isDisabled={isCreativesgenerating}
                                                                                                    isChecked={selectedCreativeImages.includes(result)}
                                                                                                    onChange={() => handleCreativeCheckboxChange(result)}
                                                                                                    colorScheme="brand"
                                                                                                    border="1px"
                                                                                                    borderColor="gray.50"
                                                                                                />
                                                                                                <Box
                                                                                                    position="absolute"
                                                                                                    bottom="5px"
                                                                                                    left="5px"
                                                                                                    opacity="0"
                                                                                                    _groupHover={{ opacity: 1 }}
                                                                                                    zIndex="2"
                                                                                                    bg="#fff"
                                                                                                    borderRadius="sm"
                                                                                                >
                                                                                                    <Tooltip
                                                                                                        label={<Image src={result} width="300px" />}
                                                                                                        bg="gray.50"
                                                                                                        p="1"
                                                                                                    >
                                                                                                        <IconButton
                                                                                                            aria-label="Preview Image"
                                                                                                            icon={<FiEye />}
                                                                                                            size="xs"
                                                                                                            variant="ghost"
                                                                                                            color={"gray.600"}
                                                                                                            _hover={{
                                                                                                                background: 'none',
                                                                                                            }}
                                                                                                        />
                                                                                                    </Tooltip>
                                                                                                </Box>
                                                                                            </>
                                                                                        ) : null}
                                                                                    </Box>
                                                                                );
                                                                            })}
                                                                        </Flex>

                                                                        <Box mt="20px">
                                                                            <Box mb="10px">
                                                                                <Text fontWeight="bold" fontSize="12px">
                                                                                    Like what you see but not sure yet?
                                                                                </Text>
                                                                                <Text fontSize="12px">
                                                                                    Click Generate to see more similar backgrounds.
                                                                                </Text>
                                                                            </Box>
                                                                            <Box cursor={isCreativesGenerating || isBgCreativesGenerating ? "not-allowed" : "pointer"}>
                                                                                <Text fontWeight="bold" fontSize="12px">
                                                                                    Don't like the results?
                                                                                </Text>
                                                                                <Text fontSize="12px">
                                                                                    Click{" "}
                                                                                    <Link
                                                                                        onClick={() => {
                                                                                            if (!isCreativesGenerating) {
                                                                                                setVariationHasEdit(true);
                                                                                            }
                                                                                        }}
                                                                                        fontWeight="bold"
                                                                                        color={isCreativesGenerating || isBgCreativesGenerating ? "gray.400" : "none"}
                                                                                        _hover={{ textDecoration: isCreativesGenerating || isBgCreativesGenerating ? "none" : "underline" }}
                                                                                        pointerEvents={isCreativesGenerating || isBgCreativesGenerating ? "none" : "auto"}
                                                                                    >
                                                                                        here
                                                                                    </Link>{" "}
                                                                                    to edit the prompt based on your requirements and click Generate.
                                                                                </Text>
                                                                            </Box>
                                                                        </Box>
                                                                    </>
                                                                ) : null}
                                                            </>
                                                        )}
                                                </>
                                            ) : null}
                                        </Flex>

                                    </Box>
                                </>
                            )}

                        </Flex>
                    </ModalBody>
                    <ModalFooter>
                        <Flex width="100%" justifyContent="space-between" alignItems="center">
                            {/* Left Side */}
                            {currentStep === 1 ? (
                                <Flex alignItems="center" gap="8px">
                                    <InfoOutlineIcon fontSize="12px" />
                                    <Text fontSize="12px">
                                        AI-generated images will be created in the same dimensions as the uploaded image and will be stored only in the "My Drive" of the designated Ad Accounts.
                                    </Text>
                                </Flex>
                            ) :
                                <Flex>
                                </Flex>
                            }

                            {/* Right Side: Back or Next Button */}
                            <Flex gap={2}>
                                {currentStep === 0 && (
                                    <Flex>
                                        <Button size="sm" colorScheme="brand" onClick={handleNext} isDisabled={showAdAccountError}>
                                            Next
                                        </Button>
                                    </Flex>
                                )}
                                {currentStep === 1 && (
                                    <Flex gap={2}>
                                        <Button 
                                            colorScheme="gray"
                                            variant="solid"
                                            size="sm" 
                                            onClick={handleBack}>
                                            Back
                                        </Button>
                                        <Button
                                            colorScheme="brand"
                                            size="sm"
                                            onClick={uploadFormik.handleSubmit}
                                            isDisabled={showAdAccountError || !uploadFormik.isValid || isCreativesGenerating || isBgCreativesGenerating}
                                        >
                                            Save
                                        </Button>
                                    </Flex>
                                )}
                            </Flex>
                        </Flex>
                    </ModalFooter>
                </ModalContent>
            </Modal >
        </>
    );
};

export default UploadImageModal;